(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dice-fights-ember"]) return;
  try {
    
(() => {
  function initDiceFights(root) {
    if (!root || root.dataset.initialized) return;
    const configNode = root.querySelector('[data-df-config]');
    if (!configNode) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch { return; }
    root.dataset.initialized = 'true';
    const forms = [...root.querySelectorAll('[data-df-form]')];
    const buttons = [...root.querySelectorAll('[data-df-submit]')];
    const track = root.querySelector('[data-df-track]');
    const cards = [...root.querySelectorAll('[data-df-card]')];
    let selectedQuantity = 2;
    let scrollTimer;
    const cartUrl = root.dataset.cartUrl.replace(/\/$/, '');
    let busy = false;
    const quantityFor = value => Math.max(1, Math.min(3, Math.floor(Number(value) || 1)));
    const productsFor = quantity => [config.base, ...(quantity >= 2 ? [config.expansion] : []), ...(quantity >= 3 ? [config.mat] : [])];
    const isReady = quantity => Boolean(config.base.id && config.base.available && config.base.price > 0 && productsFor(quantity).slice(1).every(item => item.id && item.available && (quantity === 2 ? item.price > 0 : item.price === 0)));
    const unavailableCopy = quantity => !config.base.available || config.base.price <= 0 ? config.copy.unavailable : config.copy.giftUnavailable;
    const updateForm = (form, value) => {
      const quantity = quantityFor(value);
      form.querySelector('[name="quantity"]').value = quantity;
      const tier = config.tiers[quantity - 1];
      const price = form.closest('.df-purchase')?.querySelector('[data-df-form-price]');
      if (price) price.textContent = tier.price;
      const ready = isReady(quantity);
      form.querySelectorAll('[data-df-submit]').forEach(button => { button.disabled = busy || !ready; });
      const status = form.querySelector('[data-df-status]');
      status.textContent = ready ? '' : unavailableCopy(quantity);
      status.hidden = ready;

    };
    const request = async (url, body) => {
      const response = await fetch(url, body === undefined ? {headers:{Accept:'application/json'}} : {
        method:'POST', headers:{Accept:'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'}, body:JSON.stringify(body)
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || root.dataset.error);
      return result;
    };
    root.querySelectorAll('[data-df-accessory-form]').forEach(form => {
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || form.dataset.ready !== 'true') return;
        const trigger = event.submitter || form.querySelector('[data-df-accessory-submit]');
        const modal = trigger.closest('[data-df-gallery-dialog]');
        const status = modal?.querySelector('[data-df-accessory-status]') || form.querySelector('[data-df-accessory-status]');
        const submitButtons = [...form.elements].filter(element => element.matches('[data-df-accessory-submit]'));
        const variantId = form.querySelector('[name="id"]').value;
        const originalLabel = trigger.innerHTML;
        busy = true;
        submitButtons.forEach(button => { button.disabled = true; });
        trigger.textContent = root.dataset.adding;
        status.hidden = true;
        form.setAttribute('aria-busy', 'true');
        const releaseTierLock = window.DODGameTiers?.begin();
        try {
          const fresh = await request(form.dataset.productUrl);
          const variant = fresh.variants.find(item => String(item.id) === variantId);
          if (!variant?.available || variant.price <= 0 || variant.price !== Number(form.dataset.price)) throw new Error(config.copy.changed);
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const payload = {items:[{id:variantId,quantity:1}]};
          if (typeof cart?.getSectionsToRender === 'function') {
            payload.sections = cart.getSectionsToRender().map(section => section.id);
            payload.sections_url = window.location.pathname;
            cart.setActiveElement?.(modal ? document.getElementById(modal.dataset.openerId) || trigger : trigger);
          }
          let result = await request(root.dataset.addUrl + '.js', payload);
          result = await window.DODGameTiers.sync(result, payload.sections);
          status.hidden = false;
          status.textContent = root.dataset.added;
          if (modal?.open) modal.close();
          if (typeof cart?.renderContents === 'function' && result.sections && Object.values(result.sections).every(Boolean)) {
            try { cart.classList.remove('is-empty'); cart.renderContents({...result,id:variantId}); }
            catch { window.location.assign(cartUrl); }
          } else window.location.assign(cartUrl);
        } catch (failure) {
          status.textContent = failure.message || root.dataset.error;
          status.hidden = false;
        } finally {
          busy = false;
          trigger.innerHTML = originalLabel;
          submitButtons.forEach(button => { button.disabled = form.dataset.ready !== 'true'; });
          form.removeAttribute('aria-busy');
          releaseTierLock?.();
        }
      });
    });
    const rollback = async token => {
      const cart = await request(cartUrl + '.js');
      const updates = Object.fromEntries(cart.items.filter(item => item.properties?._dice_fights_bundle === token).map(item => [item.key, 0]));
      if (Object.keys(updates).length) {
        const updated = await request(cartUrl + '/update.js', {updates});
        window.DODGameTiers.render(await window.DODGameTiers.sync(updated));
      }
    };
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const selectBundle = (value, move = true, instant = false) => {
      selectedQuantity = quantityFor(value);
      root.querySelectorAll('[data-df-tier]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.dfTier) === selectedQuantity)));
      cards.forEach(card => card.classList.toggle('is-selected', Number(card.dataset.dfCard) === selectedQuantity));
      const announcement = root.querySelector('[data-df-bundle-announcement]');
      if (announcement) announcement.textContent = config.tiers[selectedQuantity - 1].label + '. ' + config.tiers[selectedQuantity - 1].included;
      const card = cards[selectedQuantity - 1];
      if (move && track && card) {
        window.clearTimeout(scrollTimer);
        track.scrollTo({left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior: instant || reducedMotion ? 'instant' : 'smooth'});
      }
    };
    root.querySelectorAll('[data-df-gift-tier]').forEach(link => link.addEventListener('click', event => {
      if (Number(link.dataset.dfGiftTier) === 2) {
        event.preventDefault();
        if (!busy) root.querySelector('[data-df-card="2"] [data-df-bundle-form]')?.requestSubmit();
      } else if (!busy) selectBundle(link.dataset.dfGiftTier);
    }));
    root.querySelectorAll('[data-df-tier]').forEach(button => button.addEventListener('click', () => {
      if (!busy) selectBundle(button.dataset.dfTier);
    }));
    if (track && cards.length) {
      const syncSelectionFromScroll = () => {
        window.clearTimeout(scrollTimer);
        const center = track.scrollLeft + track.clientWidth / 2;
        const nearest = cards.reduce((best, card) => Math.abs(card.offsetLeft + card.offsetWidth / 2 - center) < Math.abs(best.offsetLeft + best.offsetWidth / 2 - center) ? card : best, cards[0]);
        selectBundle(nearest.dataset.dfCard, false);
      };
      track.addEventListener('scroll', () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(syncSelectionFromScroll, 150);
      }, {passive: true});
      track.addEventListener('scrollend', syncSelectionFromScroll);
      track.addEventListener('keydown', event => {
        if (busy || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        selectBundle(event.key === 'Home' ? 1 : event.key === 'End' ? 3 : selectedQuantity + (event.key === 'ArrowRight' ? 1 : -1));
      });
      new ResizeObserver(() => selectBundle(selectedQuantity, true, true)).observe(track);
      requestAnimationFrame(() => selectBundle(2, true, true));
    }
    forms.forEach(form => {
      const input = form.querySelector('[name="quantity"]');
      form.querySelector('[data-df-minus]')?.addEventListener('click', () => { if (!busy) updateForm(form, Number(input.value) - 1); });
      form.querySelector('[data-df-plus]')?.addEventListener('click', () => { if (!busy) updateForm(form, Number(input.value) + 1); });
      input.addEventListener('change', () => { if (!busy) updateForm(form, input.value); });
      updateForm(form, input.value);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (busy || !window.fetch) return;
        const quantity = quantityFor(input.value);
        updateForm(form, quantity);
        if (!isReady(quantity) || !form.reportValidity()) return;
        const buyNow = Boolean(event.submitter?.hasAttribute('data-df-buy'));
        const trigger = event.submitter || form.querySelector('[data-df-submit]');
        const error = form.querySelector('[data-df-error]');
        const status = form.querySelector('[data-df-status]');
        const labels = new Map(buttons.map(button => [button, button.innerHTML]));
        const products = productsFor(quantity);
        const token = 'dice-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        let addAttempted = false;
        busy = true;
        root.querySelectorAll('[data-df-error]').forEach(node => { node.hidden = true; });
        buttons.forEach(button => { button.disabled = true; });
        root.querySelectorAll('[data-df-tier],[data-df-plus],[data-df-minus]').forEach(button => { button.disabled = true; });
        trigger.textContent = root.dataset.adding;
        form.setAttribute('aria-busy', 'true');
        const releaseTierLock = window.DODGameTiers.begin();
        try {
          await Promise.all(products.map(async (product, index) => {
            const fresh = await request(product.url);
            const variant = fresh.variants.find(item => String(item.id) === String(product.id));
            if (!variant?.available || variant.price !== product.price || (index === 0 || quantity === 2 ? variant.price <= 0 : variant.price !== 0)) throw new Error(config.copy.changed);
          }));
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const payload = {items:products.map((product, index) => ({id:product.id,quantity:index === 0 ? quantity : 1,properties:{_dice_fights_bundle:token}}))};
          if (!buyNow && typeof cart?.getSectionsToRender === 'function') {
            payload.sections = cart.getSectionsToRender().map(section => section.id);
            payload.sections_url = window.location.pathname;
            cart.setActiveElement?.(trigger);
          }
          addAttempted = true;
          let result = await request(root.dataset.addUrl + '.js', payload);
          result = await window.DODGameTiers.sync(result, payload.sections);
          const current = result;
          const added = current.items.filter(item => item.properties?._dice_fights_bundle === token);
          const baseCount = added.filter(item => String(item.variant_id) === String(config.base.id)).reduce((sum, item) => sum + item.quantity, 0);
          const giftsOK = products.slice(1).every(product => {
            const lines = added.filter(item => String(item.variant_id) === String(product.id));
            return lines.reduce((sum, item) => sum + item.quantity, 0) === 1 && (quantity === 2 || lines.every(item => item.final_line_price === 0));
          });
          if (baseCount !== quantity || !giftsOK) throw new Error(config.copy.changed);
          if (buyNow) { window.location.assign(cartUrl + '/checkout'); return; }
          status.hidden = false;
          status.textContent = root.dataset.added;
          if (typeof cart?.renderContents === 'function' && result.sections && Object.values(result.sections).every(Boolean)) {
            try { cart.classList.remove('is-empty'); cart.renderContents({...result,id:config.base.id}); }
            catch { window.location.assign(cartUrl); }
          } else { window.location.assign(cartUrl); }
        } catch (failure) {
          let message = failure.message || root.dataset.error;
          if (addAttempted) {
            try { await rollback(token); }
            catch { message += ' ' + config.copy.reviewCart; }
          }
          error.textContent = message;
          error.hidden = false;
          error.setAttribute('tabindex', '-1');
          error.focus();
        } finally {
          busy = false;
          buttons.forEach(button => { button.innerHTML = labels.get(button); });
          root.querySelectorAll('[data-df-tier],[data-df-plus],[data-df-minus]').forEach(button => { button.disabled = false; });
          forms.forEach(currentForm => currentForm.querySelectorAll('[data-df-submit]').forEach(button => { button.disabled = !isReady(quantityFor(currentForm.querySelector('[name="quantity"]').value)); }));
          form.removeAttribute('aria-busy');
          releaseTierLock();
        }
      });
    });
  }
  const initialize = () => document.querySelectorAll('[data-df-root]').forEach(initDiceFights);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dod-occasion-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dod-home-pack')) {
    customElements.define('dod-home-pack', class extends HTMLElement {
      connectedCallback() {
        this.resize = new ResizeObserver(() => this.fit());
        this.resize.observe(this);
        this.fit();
      }
      disconnectedCallback() { this.resize?.disconnect(); }
      fit() {
        const pack = this.querySelector('[data-bounds]');
        const image = pack?.querySelector('img');
        if (!image || !this.clientWidth || !this.clientHeight) return;
        const [left, top, right, bottom, width, height] = pack.dataset.bounds.split(',').map(Number);
        const scale = Math.min(this.clientWidth * .96 / (right - left), this.clientHeight * .96 / (bottom - top));
        if (!Number.isFinite(scale) || scale <= 0) return;
        this.classList.add('is-fitted');
        Object.assign(image.style, {width: width * scale + 'px', height: height * scale + 'px', left: (this.clientWidth - (right - left) * scale) / 2 - left * scale + 'px', top: (this.clientHeight - (bottom - top) * scale) / 2 - top * scale + 'px'});
        image.sizes = Math.ceil(width * scale) + 'px';
      }
    });
  }
  function initializeOccasionHome(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const buttons = [...root.querySelectorAll('[data-occasion-filter]')];
    const occasionLinks = [...root.querySelectorAll('[data-occasion-select]')];
    const cards = [...root.querySelectorAll('[data-occasion-game]')];
    const status = root.querySelector('[data-occasion-status]');
    const results = root.querySelector('[data-occasion-results-heading]');
    const browse = root.querySelector('.dod-occasions__browse');
    const filters = root.querySelector('[data-occasion-filters]');
    const grid = root.querySelector('.dod-occasions__products');

    function select(category, moveFocus) {
      if (!buttons.some(button => button.dataset.occasionFilter === category)) category = 'all';
      root.querySelector("[data-occasion-browse-all]").hidden = false;
      let count = 0;
      cards.forEach(card => {
        const show = category === 'all' || card.dataset.category.split(/\s+/).includes(category);
        card.hidden = !show;
        if (show) count++;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.occasionFilter === category)));
      occasionLinks.forEach(link => link.setAttribute('aria-current', String(link.dataset.occasionSelect === category)));
      const active = buttons.find(button => button.dataset.occasionFilter === category);
      status.textContent = status.dataset.message.replace('[count]', String(count)).replace('[category]', active.textContent.trim());
      if (moveFocus) {
        results.focus({ preventScroll: true });
        browse.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      }
    }
    const requested = new URLSearchParams(window.location.search).get('occasion');
    const requestedOccasion = requested === 'girls' ? 'party' : requested;
    if (['all', 'party', 'date', 'family'].includes(requestedOccasion)) {
      select(requestedOccasion, false);
      const revealOccasion = () => {
        browse.scrollIntoView({ block: 'start', behavior: 'instant' });
        results.focus({ preventScroll: true });
      };
      if (document.readyState === 'complete') requestAnimationFrame(revealOccasion);
      else window.addEventListener('load', revealOccasion, { once: true });
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      const pinned = filters.getBoundingClientRect().top <= parseFloat(getComputedStyle(filters).top) + 1;
      select(button.dataset.occasionFilter, false);
      if (pinned) {
        root.style.setProperty('--dod-filter-height', `${filters.offsetHeight}px`);
        grid.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
    }));
    occasionLinks.forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      select(link.dataset.occasionSelect, true);
    }));
  }
  document.querySelectorAll('[data-occasion-home]').forEach(initializeOccasionHome);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-occasion-home]').forEach(initializeOccasionHome));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dod-quick-buy"]) return;
  try {
    

  function retailObservedHoliday(year, month, day) {
    const date = new Date(year, month, day, 12);
    if (date.getDay() === 6) date.setDate(date.getDate() - 1);
    if (date.getDay() === 0) date.setDate(date.getDate() + 1);
    return date;
  }
  function retailBusinessDay(date) {
    if (date.getDay() === 0 || date.getDay() === 6) return false;
    const year = date.getFullYear();
    const holidays = [[0,1],[5,19],[6,4],[10,11],[11,25]].map(([month,day]) => retailObservedHoliday(year,month,day));
    holidays.push(retailObservedHoliday(year+1,0,1));
    const nth = (month, weekday, n) => { const d = new Date(year,month,1,12); d.setDate(1+(weekday-d.getDay()+7)%7+7*(n-1)); return d; };
    holidays.push(nth(0,1,3),nth(1,1,3),nth(8,1,1),nth(9,1,2),nth(10,4,4));
    const memorial = new Date(year,5,0,12); memorial.setDate(memorial.getDate()-(memorial.getDay()+6)%7); holidays.push(memorial);
    return !holidays.some(holiday => holiday.toDateString() === date.toDateString());
  }
  function retailAddBusinessDays(start, count) {
    const date = new Date(start); date.setHours(12,0,0,0);
    while (count > 0) { date.setDate(date.getDate()+1); if (retailBusinessDay(date)) count--; }
    return date;
  }
  function setRetailDelivery(root) {
    const target = root.querySelector('[data-retail-delivery]');
    const parts = new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date());
    const values = Object.fromEntries(parts.map(part => [part.type,part.value]));
    const dispatch = retailAddBusinessDays(new Date(Number(values.year),Number(values.month)-1,Number(values.day),12),1);
    let start, end;
    if (root.dataset.country === 'US') {
      const min = Math.max(1,Number(root.dataset.shippingMin)||4);
      const max = Math.max(min,Number(root.dataset.shippingMax)||5);
      start = retailAddBusinessDays(dispatch,min); end = retailAddBusinessDays(dispatch,max);
    } else {
      start = new Date(dispatch); end = new Date(dispatch); start.setDate(start.getDate()+7); end.setDate(end.getDate()+14);
    }
    const formatter = new Intl.DateTimeFormat(root.dataset.locale || 'en-US',{month:'short',day:'numeric'});
    target.textContent = formatter.format(start) + '–' + (start.getMonth() === end.getMonth() ? end.getDate() : formatter.format(end));
    target.setAttribute('title',new Intl.DateTimeFormat(root.dataset.locale || 'en-US',{dateStyle:'full'}).format(start)+' – '+new Intl.DateTimeFormat(root.dataset.locale || 'en-US',{dateStyle:'full'}).format(end));
  }

  function initializeQuickBuy(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('.dod-qb__form');
    const buttons = [...root.querySelectorAll('[data-qb-submit]')];
    const status = root.querySelector('[data-qb-status]');
    const errors = [...root.querySelectorAll('[data-qb-error], [data-qb-sticky-error]')];
    const slides = [...root.querySelectorAll('[data-qb-slide]')];
    const thumbnails = [...root.querySelectorAll('[data-qb-thumbnail]')];
    const zoom = root.querySelector('.dod-qb__zoom');
    const zoomImage = root.querySelector('[data-qb-zoom-image]');
    const selector = root.querySelector('[data-qb-variant]');
    const quantity = form.querySelector('[name="quantity"]');
    const minus = root.querySelector('[data-retail-minus]');
    const plus = root.querySelector('[data-retail-plus]');
    function updateQuantityButtons() {
      minus.disabled = Number(quantity.value) <= Number(quantity.min);
      plus.disabled = quantity.max !== '' && Number(quantity.value) >= Number(quantity.max);
    }
    minus.addEventListener('click', () => { quantity.stepDown(); updateQuantityButtons(); });
    plus.addEventListener('click', () => { quantity.stepUp(); updateQuantityButtons(); });
    quantity.addEventListener('input', updateQuantityButtons);
    updateQuantityButtons();
    let busy = false;
    let confirmed = false;
    let available = !buttons[0].disabled;
    function updateButtons() {
      buttons.forEach(button => {
        button.disabled = busy || !available;
        button.setAttribute('aria-busy', String(busy));
        button.querySelector('[data-qb-submit-label]').textContent = busy ? (confirmed ? root.dataset.added : root.dataset.adding) : available ? (button.dataset.buyLabel || root.dataset.addLabel) : root.dataset.soldLabel;
      });
    }
    function showError(message) {
      errors.forEach(error => { error.textContent = message; error.hidden = !message; });
    }
    const stage = root.querySelector('[data-qb-track]');
    const strip = root.querySelector('.dod-qb__thumbnails');
    const previous = root.querySelector('[data-qb-prev]');
    const next = root.querySelector('[data-qb-next]');
    let activeIndex = -1;
    const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    function markPhoto(index) {
      if (index === activeIndex || !slides[index]) return;
      activeIndex = index;
      slides.forEach((slide, i) => {
        slide.inert = i !== index;
        if (i !== index) {
          slide.querySelectorAll('video').forEach(video => video.pause());
          slide.querySelectorAll('[data-qb-external]').forEach(container => {
            container.querySelector('iframe')?.remove();
            container.querySelector('[data-qb-video-launch]').hidden = false;
          });
        }
      });
      thumbnails.forEach((thumbnail, i) => thumbnail.setAttribute('aria-current', String(i === index)));
      if (strip && thumbnails[index]) {
        const thumb = thumbnails[index];
        strip.scrollTo({ left: thumb.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2, behavior: motion() });
      }
      const counter = root.querySelector('[data-qb-counter]');
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }
    function choosePhoto(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      stage.scrollTo({ left: index * stage.clientWidth, behavior: motion() });
      markPhoto(index);
    }
    function fitPackImage() {
      if (!root.dataset.packBounds) return;
      const image = slides.find(slide => slide.dataset.mediaId === root.dataset.packMedia)?.querySelector('a > img');
      if (!image) return;
      const [left,top,right,bottom,width,height] = root.dataset.packBounds.split(',').map(Number);
      const frameWidth = stage.clientWidth, frameHeight = stage.clientHeight;
      const scale = Math.min(frameWidth * .94 / (right-left),frameHeight * .94 / (bottom-top));
      Object.assign(image.style,{position:'absolute',maxWidth:'none',maxHeight:'none',width:width*scale+'px',height:height*scale+'px',left:((frameWidth-(right-left)*scale)/2-left*scale)+'px',top:((frameHeight-(bottom-top)*scale)/2-top*scale)+'px'});
    }
    fitPackImage();
    markPhoto(0);
    let scrollFrame;
    stage.addEventListener('scroll', () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => markPhoto(Math.round(stage.scrollLeft / stage.clientWidth)));
    }, { passive:true });
    previous?.addEventListener('click', () => choosePhoto(activeIndex - 1));
    next?.addEventListener('click', () => choosePhoto(activeIndex + 1));
    const galleryKeys = (event, index) => {
      if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : Math.max(0, Math.min(slides.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1)));
      choosePhoto(nextIndex);
      if (event.currentTarget !== stage) thumbnails[nextIndex].focus({preventScroll:true});
    };
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', event => { event.preventDefault(); choosePhoto(index); });
      thumbnail.addEventListener('keydown', event => galleryKeys(event, index));
    });
    stage.addEventListener('keydown', event => { if (event.target === stage) galleryKeys(event, activeIndex); });
    new ResizeObserver(() => { fitPackImage(); stage.scrollTo({left:Math.max(0,activeIndex)*stage.clientWidth,behavior:'instant'}); }).observe(stage);
    root.querySelectorAll('[data-qb-video-launch]').forEach(button => button.addEventListener('click', () => {
      const container = button.closest('[data-qb-external]');
      container.appendChild(container.querySelector('template').content.cloneNode(true));
      button.hidden = true;
      container.querySelector('iframe')?.focus();
    }));
    root.querySelectorAll('[data-qb-image-open], [data-qb-contents-open]').forEach(link => link.addEventListener('click', event => {
      if (!zoom.showModal) return;
      event.preventDefault();
      zoomImage.src = link.href;
      zoomImage.alt = link.querySelector('img').alt;
      zoom.showModal();
    }));
    root.querySelector('[data-qb-zoom-close]').addEventListener('click', () => zoom.close());
    zoom.addEventListener('click', event => { if (event.target === zoom) zoom.close(); });
    root.querySelectorAll('[data-qb-shipping]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      const details = root.querySelector('[data-qb-shipping-details]');
      details.open = true;
      details.querySelector('summary').focus({ preventScroll: true });
      details.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    }));
    if (selector) selector.addEventListener('change', () => {
      const option = selector.selectedOptions[0];
      available = option.dataset.available === 'true';
      root.querySelectorAll('[data-qb-price]').forEach(price => price.textContent = option.dataset.price);
      quantity.min = option.dataset.quantity;
      quantity.step = option.dataset.step;
      quantity.max = option.dataset.max || '';
      quantity.value = option.dataset.quantity;
      updateQuantityButtons();
      const mediaIndex = slides.findIndex(slide => slide.dataset.mediaId === option.dataset.media);
      if (mediaIndex >= 0) choosePhoto(mediaIndex);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
      showError('');
      updateButtons();
    });
    setRetailDelivery(root);
    const initialMedia = selector?.selectedOptions[0]?.dataset.media || root.dataset.initialMedia;
    const initialIndex = slides.findIndex(slide => slide.dataset.mediaId === initialMedia);
    if (initialIndex > 0) choosePhoto(initialIndex);
    form.addEventListener('submit' , async event => {
      if (!window.fetch) return;
      event.preventDefault();
      if (busy || !available) return;
      busy = true;
      confirmed = false;
      const releaseTierLock = window.DODGameTiers?.begin();
      showError('');
      updateButtons();
      const buyNow = Boolean(event.submitter && event.submitter.hasAttribute('data-qb-buy-now'));
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const sections = cart?.getSectionsToRender?.().map(section => section.id) || [];
      const popup = !buyNow && cart?.tagName === 'CART-DRAWER' && window.DODGameTiers ? window.DODAfterAdd : null;
      let popupOpened = false;
      const data = new FormData(form);
      if (!buyNow && sections.length) {
        data.append('sections', [...sections, ...(popup ? ['dod-cart-state'] : [])].join(','));
        data.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(event.submitter || document.activeElement);
      }
      try {
        const response = await fetch(root.dataset.addUrl + '.js', { method:'POST', headers:{ 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' }, body:data });
        let result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : root.dataset.error);
        confirmed = true;
        status.textContent = root.dataset.added;
        updateButtons();
        // Confirm the successful add before waiting for gift/discount reconciliation.
        // The cart snapshot is for display only; sync still reads discount codes from Shopify.
        if (popup && result.sections?.['dod-cart-state']) {
          try {
            const state = new DOMParser().parseFromString(result.sections['dod-cart-state'], 'text/html').querySelector('[data-dod-cart-state]');
            const snapshot = JSON.parse(state.textContent);
            popupOpened = popup.open({ ...result, ...snapshot }, cart, true) === true;
          } catch (_) {}
        }
        if (result.sections) delete result.sections['dod-cart-state'];
        if (window.DODGameTiers) result = await window.DODGameTiers.sync(result, buyNow ? [] : sections);
        if (buyNow) {
          window.location.assign(root.dataset.cartUrl.replace(/\/$/, '') + '/checkout');
          return;
        }
        status.textContent = root.dataset.added;
        if (cart && typeof cart.renderContents === 'function' && result.sections && Object.values(result.sections).every(Boolean)) {
          try {
            cart.classList.remove('is-empty');
            cart.renderContents(result, !popupOpened);
            if (popupOpened) popup.finishSync(result);
          } catch (error) {
            window.location.assign(root.dataset.cartUrl);
          }
        } else {
          window.location.assign(root.dataset.cartUrl);
        }
      } catch (error) {
        if (popupOpened) popup.finishSync(null, error);
        else if (confirmed) window.location.assign(root.dataset.cartUrl);
        else showError(error instanceof TypeError ? root.dataset.error : error.message || root.dataset.error);
      } finally {
        releaseTierLock?.();
        busy = false;
        confirmed = false;
        updateButtons();
      }
    });
  }
  document.querySelectorAll('[data-quick-buy]').forEach(initializeQuickBuy);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-quick-buy]').forEach(initializeQuickBuy));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
